module.exports = __webpack_public_path__ + "static/before4-7611dde77e86fdba2aa6d36c3514bd5b.jpg";